import React, { useEffect, useRef, useState } from "react";
import { FiTrash2 } from "react-icons/fi";
import { FaArrowsRotate } from "react-icons/fa6";
import ChatbotApiClient from "../../../../methods/api/chatbotapiClient";
import { ChatbotContext } from "../../TabContextProvider";
import environment from "../../../../environment";
import loader from "../../../../methods/loader";
import { FaThumbsDown, FaThumbsUp } from "react-icons/fa";
import { toast } from "react-toastify";
import DOMPurify from "dompurify";
import { FiChevronsLeft, FiChevronsRight } from "react-icons/fi";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import parse from "html-react-parser";
import { useSelector } from "react-redux";
import ApiClient from "../../../../methods/api/apiClient";
import datepipeModel from "../../../../models/datepipemodel";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SelectDropdown from "../../../../components/common/SelectDropdown";
import methodModel from "../../../../methods/methods";
import DeleteConnection from "../../../../components/alerts/DeleteConnection";
import swal from "sweetalert";
import "./chatbot.css";
const ChatBot = () => {
  const { chatbotData, chatbotAppearanceData, setChatbotData } =
    React.useContext(ChatbotContext);

  const user = useSelector((state) => state.user);
  const [showSource, setShowSource] = useState(false);
  const [lastChatSource, setLastChatSource] = useState([]);
  const [mymessages, setmymessages] = useState([]);
  const [chatbotHistory, setChatbotHistory] = useState([]);
  const [inputText, setInputText] = useState("");
  const [isGenerating, setisGenerating] = useState(false);
  const scrollbarRef = useRef(null);
  const chatResponseRef = useRef(null);
  const [actions, setActions] = useState([]);
  const [DropdownList, setDropDownList] = useState([]);
  const [DropdownValue, setDropdownValue] = useState("");
  const [Buttons, setButtons] = useState([]);

  const [WidgetSettings, setWidgetSettings] = useState({
    buttonStyle: "",
    colorTheme: "#5d62df",
    size: "",
    radius: 0,
    logo: "",
    iconSize: 64,
    position: "right",
    xAxis: 0,
    yAxis: 0,
    iconText: "",
    title: "",
    description: "",
    label: "",
    menuSize: "",
    menuWidth: 200,
    menuIconStyle: "",
    menuBorder: "",
    menuBorderColor: "#5d62df",
    menuIconColor: "#5d62df",
    menuBackground: "#ffffff",
    menuTitleColor: "#000000",
    hoverItemBg: "#5d62df",
    hoverItemTitleColor: "#000000",
    menuShadowSize: 0,
    menuShadowOpacity: 0,
    chat_bubble_color: "#412092",
    chat_bubble_show: true,
    chat_bubble_logo: false,
    showHeader: false,
  });

  const ProductDetailsSlider1 = {
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    nextArrow: (
      <SampleNextArrow
        size={22}
        child="xl:!-right-[6px] !-translate-y-1/2 !w-[24px] lg:!w-[40px] !h-[24px] lg:!h-[40px]"
      />
    ),
    prevArrow: (
      <SamplePrevArrow
        size={22}
        child="xl:!-left-[1px]  !-translate-y-1/2 !w-[24px] lg:!w-[40px] !h-[24px] lg:!h-[40px]"
      />
    ),
  };

  function SampleNextArrow(props) {
    const { className, child, onClick, size } = props;
    return (
      <div
        className={`${className}   cursor-pointer hover:opacity-80 !bg-gray-100 rounded-full !flex !items-center !justify-center before:!content-[''] ${child}`}
        onClick={onClick}
      >
        <MdOutlineKeyboardBackspace
          className="text-[#9b8f8f] rotate-180"
          size={size ? size : 26}
        />
      </div>
    );
  }
  function SamplePrevArrow(props) {
    const { child, className, onClick, size } = props;
    return (
      <div
        className={`${className} ${child}  z-10 cursor-pointer hover:opacity-80 !bg-gray-100 rounded-full !flex !items-center !justify-center before:!content-['']`}
        onClick={onClick}
      >
        <MdOutlineKeyboardBackspace
          className="text-[#9b8f8f]"
          size={size ? size : 26}
        />
      </div>
    );
  }

  useEffect(() => {
    if (showSource && chatbotData.id) {
      loader(true);
      ChatbotApiClient.get(`api/last-chat-source/`, {
        chatbot_id: chatbotData.id,
      }).then(async (res) => {
        const response = await res;
        if (response.success) {
          setLastChatSource(response.data);
        }
        loader(false);
      });
    }
  }, [showSource, chatbotData]);

  useEffect(() => {
    if (chatbotData?.id) {
      loader(true);
      ChatbotApiClient.post(`api/chatbot-chat-list/`, {
        chatbot_id: chatbotData.id,
      }).then(async (res) => {
        const response = await res;
        if (response.success) {
          setChatbotHistory(response.data);
        }
        await scrollToBottom();
        loader(false);
      });
    }
  }, [chatbotData]);

  const scrollToBottom = () => {
    setTimeout(() => {
      if (scrollbarRef.current) {
        scrollbarRef.current.scrollTop = scrollbarRef.current.scrollHeight;
      }
    }, 100); // Delay might be needed to wait for the DOM to update
  };

  const appendMessage = (text, sender) => {
    setmymessages((prevMessages) => [
      ...prevMessages,
      {
        text: text,
        sender: sender, // 'user' or 'bot'
        time: new Date().toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
        received: new Date().toISOString(),
      },
    ]);
    scrollToBottom();
  };

  const textPatternFormatting = (text) => {
    const pattern =
      /^(###\s*(.*$))|\*\*\[(.+?)\]\((.+?)\)\*\*|\*\*(.*?)\*\*|_(.*?)_|`(.*?)`|\[(.+?)\]\((.+?)\)|(https?:\/\/[^\s]+)|(\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b)|(\+\d{10,15})|\[Book Here\]\n\((.+?)\)/gm;

    if (text?.toLowerCase() === "want to talk live agent") {
      return "Would you like to connect with a live agent for further assistance?";
    }

    return text
      .replace(
        pattern,
        (
          match,
          header,
          headerText,
          boldLinkText,
          boldLinkUrl,
          boldText,
          italicText,
          codeText,
          linkText,
          linkUrl,
          directLink,
          email,
          phoneNumber,
          bookHereUrl,
        ) => {
          if (headerText) {
            // Handles "### Header"
            return `<h3>${headerText.trim()}</h3>`;
          } else if (boldLinkText && boldLinkUrl) {
            // Handles "**[text](url)**"
            return `<b><a href="${boldLinkUrl}" target="_blank" style="color: blue; text-decoration: underline;">${boldLinkText}</a></b>`;
          } else if (boldText) {
            // Handles "**bold text**"
            return `<b>${boldText}</b>`;
          } else if (italicText) {
            // Handles "_italic text_"
            return `<i>${italicText}</i>`;
          } else if (codeText) {
            // Handles "`inline code`"
            return `<code>${codeText}</code>`;
          } else if (linkText && linkUrl) {
            // Handles "[link text](url)"
            return `<a href="${linkUrl}" target="_blank" style="color: blue; text-decoration: underline;">${linkText}</a>`;
          } else if (email) {
            // Handles email links
            return `<a href="mailto:${email}" target="_blank" style="color: blue; text-decoration: underline;">${email}</a>`;
          } else if (phoneNumber) {
            // Handles phone numbers
            return `<a href="tel:${phoneNumber}" target="_blank" style="color: blue; text-decoration: underline;">${phoneNumber}</a>`;
          } else if (bookHereUrl) {
            // Handles "[Book Here]\n(link_url)"
            return `<a href="${bookHereUrl}" target="_blank" style="color: blue; text-decoration: underline;">Book Here</a>`;
          }
          return match; // Fallback for unmatched cases
        },
      )
      .replace(/\n/g, "<br>"); // Converts line breaks to <br>
  };

  const handleMessageSubmit = async (action = null) => {
    if (!(typeof action === "string" && action.trim() !== "")) {
      if (!inputText.trim()) return;
    }

    setisGenerating(true);

    setInputText("");
    let payload = {};
    if (typeof action === "string" && action.trim() !== "") {
      appendMessage(action, "user");
      payload = {
        question: action,
        chatbot_id: chatbotData?.id,
        src_checkbox: showSource,
        userId: user?.mainUserId,
      };
    } else {
      appendMessage(inputText, "user");
      payload = {
        question: inputText,
        chatbot_id: chatbotData?.id,
        src_checkbox: showSource,
        userId: user?.mainUserId,
      };
    }

    const response = await fetch(`${environment.api}question/ask/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify(payload),
    });

    setisGenerating(false);
    appendMessage("", "bot");

    if (!response.ok || !response.body) {
      //  Code changes because page is getting blanked after error
      swal({
        text: response.statusText || response?.data?.error,
        icon: "error",
        className: "smallModal",
      });
      return;
    }

    const contentType = response.headers.get("Content-Type");
    console.log(contentType, "contentType");
    if (contentType?.includes("application/json")) {
      processJson(response);
    } else {
      processStream(response);
    }
  };

  const handleActions = (action) => {
    handleMessageSubmit(action);
  };

  const processStream = async (response) => {
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let fullResponse = "";

    while (true) {
      const { value, done } = await reader.read();
      if (done) {
        break;
      }
      const decodedChunk = decoder.decode(value, { stream: true });
      fullResponse += decodedChunk;
      const formattedText = textPatternFormatting(fullResponse); // Define this function as needed
      // chatResponseRef.current.innerHTML = formattedText;
      setmymessages((prev) => {
        const lastIndex = prev
          .map((itm, index) => ({ itm, index }))
          .filter(({ itm }) => itm?.sender === "bot")
          .pop()?.index;
        if (lastIndex !== undefined && lastIndex >= 0) {
          return prev.map((itm, index) => {
            if (index === lastIndex) {
              return {
                ...itm,
                text: formattedText,
                received: new Date().toISOString(),
                id: response.headers?.get("chat_id"),
              };
            }
            return itm;
          });
        }
        return prev;
      });
    }
  };

  const processJson = async (response) => {
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let fullResponse = "";

    while (true) {
      const { value, done } = await reader.read();
      if (done) {
        break;
      }
      const decodedChunk = decoder.decode(value, { stream: true });
      fullResponse += decodedChunk;
    }

    const jsonResponse = JSON.parse(fullResponse);
    console.log(jsonResponse, "jsonResponse");
    await setmymessages((prev) => {
      const lastIndex = prev
        .map((itm, index) => ({ itm, index }))
        .filter(({ itm }) => itm?.sender === "bot")
        .pop()?.index;
      if (lastIndex !== undefined && lastIndex >= 0) {
        return prev.map((itm, index) => {
          if (index === lastIndex) {
            return {
              ...itm,
              text: textPatternFormatting(jsonResponse?.answer),
              received: new Date().toISOString(),
              id: response.headers?.get("chat_id"),
            };
          }
          return itm;
        });
      }
      return prev;
    });
    // Convert the string to objects
    const convertedData = jsonResponse?.actions
      .map((item) => {
        const regex = /"([^"]+)"|'([^']+)'/g;
        const matches = [...item.matchAll(regex)].map((m) => m[1] || m[2]);

        if (matches.length < 2) return null; // Ensure we have at least productName and imageUrl

        return {
          productName: matches[0], // First match is the product name
          imageUrl: matches[1], // Second match is the image URL
          description: matches[2] || "", // Third match is optional (description)
        };
      })
      .filter(Boolean); // Remove null values if parsing fails
    setActions(convertedData || []);
    setButtons(jsonResponse?.buttons);
    setDropDownList(jsonResponse?.pickups || []);
  };

  const handleInputChange = (event) => {
    setInputText(event.target.value);
  };

  const handleClearChat = async () => {
    loader(true);
    await ChatbotApiClient.post(`api/chatbot-clear-chat/`, {
      chatbot_id: chatbotData.id,
    }).then(async (res) => {
      const response = await res;
      if (response.success) {
        swal({ text: response.data, icon: "success", className: "smallModal" });
        setmymessages([]);
        setLastChatSource([]);
        setChatbotHistory([]);
      }
      loader(false);
    });
  };

  const ApiHit = async () => {
    loader(true);
    await ChatbotApiClient.post(`api/chatbot-clear-memory/`, {
      chatbot_id: chatbotData.id,
    }).then(async (res) => {
      const response = await res;
      if (response.success) {
        swal({
          text: response?.data,
          icon: "success",
          className: "smallModal",
        });
      }
      loader(false);
    });
  };
  const [confirmModal, setConfirmModal] = useState(false);

  const isValidUrl = (url) => {
    const pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i",
    ); // fragment locator
    return !!pattern.test(url);
  };

  const productSliderSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    nextArrow: (
      <SampleNextArrow
        size={22}
        child="xl:!-right-[20px] !right-[0] !-translate-y-1/2 !w-[24px] lg:!w-[40px] !h-[24px] lg:!h-[40px]"
      />
    ),
    prevArrow: (
      <SamplePrevArrow
        size={22}
        child="xl:!-left-[20px] !left-[0] !-translate-y-1/2 !w-[24px] lg:!w-[40px] !h-[24px] lg:!h-[40px]"
      />
    ),
  };

  return (
    <>
      <div className="i w-full border rounded-2xl bg-white p-5 lg:p-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 items-start gap-8">
          <DeleteConnection
            id=""
            confirmModal={confirmModal}
            setConfirmModal={() => setConfirmModal(() => !confirmModal)}
            onCancelModal={() => setConfirmModal(false)}
            imgSrc="/assets/svg/deleteerror.svg"
            description="Are you sure you want to clear your chatbot cache?"
            altText="Cache"
            keepDataText="No"
            overwriteText="Yes"
            label="Cache"
            overwriteBgColor="bg-[#115B9D]-2"
            onConfirmModal={() => ApiHit()}
          />

          <div className="border-[1.5px] border-gray-5 rounded-xl bg-white w-full">
            <div
              className="flex items-center flex-wrap justify-between rounded-t-xl py-5 px-4 border-[#f4f5f5] border-b"
              style={{
                backgroundColor: chatbotAppearanceData
                  ? chatbotAppearanceData.top_bar_background
                  : "#ffffff",
              }}
            >
              <div className="flex items-center gap-2 text-sm">
                <img
                  src={"/assets/img/logo.png"}
                  id="chatImageHeader"
                  alt=""
                  className="object-cover w-12  h-12 rounded-full"
                />
                <p
                  style={{
                    color: chatbotAppearanceData
                      ? chatbotAppearanceData.top_bar_textcolor
                      : "#000000",
                  }}
                >
                  Charles Smith & Associates Chatbot
                </p>
              </div>
              <div className="flex items-center gap-2"></div>
            </div>
            <div
              className="h-[550px] justify-end p-2 ps-5 overflow-auto"
              id="scrollbar"
              ref={scrollbarRef}
              style={{
                backgroundColor: chatbotAppearanceData
                  ? chatbotAppearanceData.chatbot_background_color
                  : "#f5f5f5",
              }}
            >
              {chatbotHistory.length === 0 &&
                mymessages.length === 0 &&
                !isGenerating && (
                  <div className="h-full flex flex-col items-center justify-center px-6 text-center">
                    <img
                      src="/assets/img/logo.png"
                      alt="Bot"
                      className="w-20 h-20 rounded-full mb-5"
                    />

                    <h2 className="text-2xl font-semibold text-gray-800">
                      Welcome to Charles Smith & Associates Chatbot 👋
                    </h2>

                    <p className="text-gray-500 text-sm mt-2 max-w-md">
                      Ask me anything about our products or services.
                    </p>

                    <div className="mt-8 flex flex-col gap-3 w-full max-w-md">
                      <button
                        onClick={() =>
                          handleMessageSubmit("What services do you provide?")
                        }
                        className="border rounded-xl px-4 py-3 text-left hover:bg-gray-100"
                      >
                        💬 What services do you provide?
                      </button>

                      <button
                        onClick={() =>
                          handleMessageSubmit("How can I contact support?")
                        }
                        className="border rounded-xl px-4 py-3 text-left hover:bg-gray-100"
                      >
                        📞 How can I contact support?
                      </button>

                      <button
                        onClick={() =>
                          handleMessageSubmit("Tell me about your company")
                        }
                        className="border rounded-xl px-4 py-3 text-left hover:bg-gray-100"
                      >
                        🏢 Tell me about your company
                      </button>
                    </div>
                  </div>
                )}

              {chatbotHistory.map((item, index) => (
                <div key={index}>
                  <div className="flex flex-col items-end justify-end gap-2.5 mb-2">
                    <div className="flex items-start justify-end gap-2.5 pr-4">
                      <p
                        className={`bg-[#F1F1F0] p-4 rounded-md text-sm leading-none text-[#2B2B2B] tracking-[0.2px]`}
                        style={{
                          backgroundColor: chatbotAppearanceData
                            ? chatbotAppearanceData.user_message_background
                            : "#ffffff",
                          color: chatbotAppearanceData
                            ? chatbotAppearanceData.user_message_color
                            : "#878787",
                        }}
                      >
                        {item.question}
                      </p>
                    </div>
                  </div>
                  <div className="flex justify-start mb-2 items-start gap-2.5 flex-col">
                    <div className="relative flex items-start justify-start gap-2.5 pr-4">
                      <img
                        src={"/assets/img/logo.png"}
                        alt=""
                        id="chatLogoImage"
                        className="shrink-0 w-8 h-8 rounded-full"
                      />
                      <div className="flex flex-col">
                        <span className="text-sm text-gray-600 mb-1 block">
                          {datepipeModel.datetime(item?.received)}
                        </span>
                        <pre
                          className="bg-[#F1F1F0] p-4 rounded-md text-sm text-gray-600 tracking-[0.2px]"
                          style={{
                            whiteSpace: "pre-wrap",
                            fontFamily: "Inter, sans-serif",
                            backgroundColor: chatbotAppearanceData
                              ? chatbotAppearanceData.bot_message_background
                              : "#ffffff",
                            color: chatbotAppearanceData
                              ? chatbotAppearanceData.bot_message_color
                              : "#878787",
                          }}
                        >
                          {parse(`${textPatternFormatting(item.answer)}`)}{" "}
                        </pre>
                      </div>
                      {/* <div className="relative mt-auto flex gap-1">
                      <button
                        type="button"
                        onClick={() => handleLikeClick(index, item)}
                        className="focus:outline-none cursor-pointer"
                      >
                        <img
                          src={
                            item?.feedback_flag == 'thumbsup'
                              ? "/assets/img/svgs/likeActive.svg"
                              : "/assets/img/svgs/like.svg"
                          }
                          alt="Like"
                          className="min-w-4 min-h-4 max-w-4 max-h-4 transition-transform duration-200"
                        />
                      </button>
                      <button
                        type="button"
                        onClick={() => handleDislikeClick(index, item)}
                        className="focus:outline-none cursor-pointer"
                      >
                        <img
                          src={
                            item?.feedback_flag == 'thumbsdown'
                              ? "/assets/img/svgs/dislikeActive.svg"
                              : "/assets/img/svgs/dislike.svg"
                          }
                          alt="Dislike"
                          className="min-w-4 min-h-4 max-w-4 max-h-4 transition-transform duration-200"
                        />
                      </button>
                    </div> */}
                    </div>
                  </div>
                </div>
              ))}

              {mymessages.map((message, index) =>
                message?.sender === "user" ? (
                  <div
                    key={index}
                    className="flex flex-col items-end justify-end gap-2.5 mb-2"
                  >
                    <div className="flex items-start justify-end gap-2.5 pr-4">
                      <p
                        className={`bg-[#F1F1F0] p-4 rounded-md text-sm leading-none text-[#2B2B2B] tracking-[0.2px]`}
                        style={{
                          backgroundColor: chatbotAppearanceData
                            ? chatbotAppearanceData.user_message_background
                            : "#ffffff",
                          color: chatbotAppearanceData
                            ? chatbotAppearanceData.user_message_color
                            : "#878787",
                        }}
                      >
                        {message.text}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div
                    key={index}
                    className="flex justify-start mb-2 items-start gap-2.5 flex-col"
                  >
                    <div className="flex items-start justify-start gap-2.5 pr-4 xl:pr-16">
                      <img
                        src={"/assets/img/logo.png"}
                        alt=""
                        id="chatLogoImage"
                        className="shrink-0 w-8 h-8 rounded-full"
                      />

                      <div className="">
                        <span className="text-sm text-gray-600 mb-1 block">
                          {" "}
                          {datepipeModel.datetime(message?.received)}
                        </span>
                        <div
                          className="bg-[#F1F1F0] p-4 rounded-md text-sm text-gray-600 tracking-[0.2px]"
                          ref={chatResponseRef}
                          style={{
                            whiteSpace: "pre-wrap",
                            fontFamily: "Inter, sans-serif",
                            backgroundColor: chatbotAppearanceData
                              ? chatbotAppearanceData.bot_message_background
                              : "#ffffff",
                            color: chatbotAppearanceData
                              ? chatbotAppearanceData.bot_message_color
                              : "#878787",
                          }}
                        >
                          {parse(`${DOMPurify.sanitize(message.text)}`)}
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 w-[88%] mx-auto  gap-4">
                      <div className="flex gap-2 flex-wrap items-center"></div>
                    </div>
                  </div>
                ),
              )}
              <div
                className={`pb-5 animate-pulse ${isGenerating ? "" : "d-none"}`}
              >
                <div className={`flex gap-2 p-4`}>
                  <img
                    src="/assets/img/svgs/stars.svg"
                    alt=""
                    className="w-[18px] h-[18px]"
                  />
                  <span className="text-sm leading-5 italic text-[#6952fa] font-light">
                    AI generating
                  </span>
                </div>

                <div className="block space-y-6 pr-4 pl-10">
                  <div className="h-2 bg-[#8675F4] rounded"></div>
                  <div className="space-y-3">
                    <div className="grid grid-cols-3 gap-4">
                      <div className="h-2 bg-[#8675F4] rounded col-span-2"></div>
                      <div className="h-2 bg-[#8675F4] rounded col-span-1"></div>
                    </div>
                    <div className="h-2 bg-[#8675F4] rounded"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-5 border-t border-[#EAECF0] flex gap-3">
              <input
                type="text"
                autoFocus
                // name=""
                // id=""
                value={inputText}
                onChange={handleInputChange}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    handleMessageSubmit();
                  }
                }}
                className="placeholder:font-light w-full h-11 shadow-box border 
              !border-grey py-2.5 px-3.5 rounded-large text-sm leading-6 text-gray-900 
              focus:outline-none focus:ring-1 focus:ring-[#115B9D]-2"
                placeholder="Send Message"
              />
              <button
                onClick={handleMessageSubmit}
                style={{
                  backgroundColor: WidgetSettings?.sendBtnBg || "#115B9D",
                }}
                type="button"
                className="w-11 !h-11 shrink-0   hover:opacity-80 flex items-center justify-center transition-all rounded-extra_large"
              >
                <img
                  src="/assets/img/svgs/send.svg"
                  alt=""
                  className="w-5 h-5"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatBot;
